import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { useDataIngestion } from "../../Hooks/useDataIngestion";
import { getQueryString } from '../../Utility/QueryString';
import { ClearAllPouchDBData } from '../../Utility/pouchdbService';
import { CheckRedirectUrl } from "../../Utility/CheckRedirectUrl";

const AnchorExternal = ({ extURL,dataId, className, children }) => {
  const { isLpUrlExist } = CheckRedirectUrl();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const screenSize = window.innerWidth + " x " + window.innerHeight;
  const { saveDataIngestion } = useDataIngestion();
  const clickRedirect = async (e) => {
    e.preventDefault();
    const redirectURL = await isLpUrlExist();
    if (visitorParameters.data != null || visitorParameters.data != undefined) {
      const pageOpen = visitorParameters.date;
      const pageClose = new Date();
      const hours = pageClose.getHours() - pageOpen.getHours();
      const minutes = pageClose.getMinutes() - pageOpen.getMinutes();
      const seconds = pageClose.getSeconds() - pageOpen.getSeconds();
      const time = (seconds + (minutes * 60) + (hours * 60 * 60));
      var min = "";
      var sec = "";
      var spent = "";
      if (time < 60) {
        spent = '00 : ' + time + ' sec';
      } else if (time < 3600) {
        min = (parseInt(time / 60));
        sec = (time % 60);
        spent = min + ' mts : ' + sec + ' sec';
      } else {
        var hur = (parseInt(time / 3600));
        var mnts = (time % 3600);
        min = (parseInt(mnts / 60));
        sec = (mnts % 60);
        spent = hur + ' hrs : ' + min + ' mts : ' + sec + ' sec';
      }
      visitorParameters.data.click_link = dataId;
      visitorParameters.data.redirectUrl = redirectURL;
      visitorParameters.data.timeSpent = spent;
      visitorParameters.data.screen = screenSize;
      visitorParameters.data.page = "2025_art/senior_benefits/v1";
      const advPagevClick = await saveDataIngestion(
        visitorParameters.visitor_parameters,
        {},
        "adv_click",
        visitorParameters.pageName,
        getQueryString,
        visitorParameters.data
      );
      if (advPagevClick.data.status === 'Success') {
        ClearAllPouchDBData();
        window.open(extURL, '_blank');
      }
    }
  };
  return (
    <>
      <Link to="#" className={className} data-id={dataId} onClick={clickRedirect}>{children}</Link>
    </>
  )
}

export default AnchorExternal;
